<div *ngIf="loading" class="card-base"></div>
<div *ngIf="!loading" class="edit-actions-cash-desk">


  <button
    matTooltip="Cancelar"
    type="button"
    (click)="close()"
    mat-icon-button
    class="card-inline"
  >
    <mat-icon>clear</mat-icon>
  </button>
</div>
<div class="card-base-actions">
  <div class="card-content-cash-desk">
    <div class="card-container mat-elevation-z1">
      <button

      matTooltip="Enviar por mail"
      type="button"
      (click)="sendMail()"
      mat-mini-fab
      class="card-inline"
    >
      <mat-icon>mail</mat-icon>
    </button>
      <div class="card-content">
        <mat-spinner *ngIf="loading"></mat-spinner>
        <div *ngIf="!loading" (resized)="onResized($event)">
          <iframe
            [style.width.px]="widthExp"
            height="500"
            *ngIf="getSafeResourceUrl()"
            [src]="getSafeResourceUrl()"
            type="application/pdf"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</div>
